export const dom = {
	get form(): HTMLFormElement | null {
		return document.getElementById('ac-checkout-form') as HTMLFormElement;
	},

	get submitBtn(): HTMLButtonElement | null {
		return document.getElementById('ac-place-order') as HTMLButtonElement;
	},

	get btnText(): HTMLSpanElement | null {
		return document.getElementById('ac-btn-text') as HTMLSpanElement;
	},

	get errorBanner(): HTMLDivElement | null {
		return document.getElementById('ac-checkout-error') as HTMLDivElement;
	},

	get errorText(): HTMLSpanElement | null {
		return document.getElementById('ac-checkout-error-text') as HTMLSpanElement;
	},

	get paypalButtons(): HTMLDivElement | null {
		return document.getElementById('ac-paypal-buttons') as HTMLDivElement;
	},

	get paypalNote(): HTMLParagraphElement | null {
		return document.getElementById('ac-paypal-note') as HTMLParagraphElement;
	},

	get pendingOrderBanner(): HTMLDivElement | null {
		return document.getElementById('ac-pending-order-banner') as HTMLDivElement;
	},

	get discardPendingOrderBtn(): HTMLButtonElement | null {
		return document.getElementById(
			'ac-discard-pending-order',
		) as HTMLButtonElement;
	},
};

export function getField(name: string): HTMLInputElement | null {
	return document.querySelector(`[name="${name}"]`);
}

export function getSelectedPaymentMethod(): string {
	return (
		document.querySelector<HTMLInputElement>('[name="payment_method"]:checked')
			?.value || 'offline'
	);
}

export function getFieldError(name: string): HTMLSpanElement | null {
	return document.querySelector(`.ac-field-error[data-field="${name}"]`);
}

export function escapeHtml(str: string): string {
	const div = document.createElement('div');
	div.appendChild(document.createTextNode(str));
	return div.innerHTML;
}
